/**
 * Syntactic sugar around adding a DOMContentLoaded handler since we do it often.
 * Ensures the handler runs after the DOM is ready, with a setTimeout(0) to
 * avoid blocking.
 */
export function onDomReady(handler: () => void): void {
   if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
         setTimeout(handler, 0);
      });
   } else {
      setTimeout(handler, 0);
   }
}

/**
 * Ensures the handler is called when the window load event fires, or
 * immediately if the load event has already fired.
 */
export function onLoad(handler: () => void): void {
   if (document.readyState === 'complete') {
      handler();
   } else {
      window.addEventListener('load', handler);
   }
}
